import React from 'react';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import Calendar from 'shared/img/education-onboarding/calendar.svg';
import styles from '../Resume/styles.module.scss';

const StayingFocused = () => (
  <BaseStep
    stepHeader={
      <>
        <Calendar className={styles.icon} width={150} />
        Earn by staying focused
      </>
    }
    subHeader={
      <>
        Every term, you&apos;ll have a checklist tailored specifically to
        <br />
        you and your college journey! Certain checklist items
        <br />
        award you micro-scholarships toward next term.
      </>
    }
  />
);

export default StayingFocused;
